import { PrivacyPolicyContent } from '@dealstack/frontend/shared/components/TermsModals/PrivacyPolicyContent';
import { TransTerms } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { ReactNode } from 'react';
import styled from 'styled-components';

interface Props {
	className?: string;
	children: ReactNode;
}

const LegalPage = ({ className, children }: Props) => {
	return (
		<main className={className}>
			<article>{children}</article>
		</main>
	);
};

const StyledLegalPage = styled(LegalPage)`
	white-space: pre-line;
	padding: 2.5rem 1.5rem;

	article {
		max-width: 48rem;
		margin: 0 auto;
	}

	* {
		line-height: 1.4em;
	}

	strong {
		font-weight: bold;
	}

	i {
		font-style: italic;
	}

	ul {
		list-style: disc;
		padding-left: 1.5em;

		li {
			margin: 0.5em;
		}

		ul {
			list-style: circle;
		}
	}
`;

export const TermsPage = () => (
	<StyledLegalPage>
		<TransTerms i18nKey="admin_terms.text_1" />
	</StyledLegalPage>
);

export const PrivacyPage = () => (
	<StyledLegalPage>
		<PrivacyPolicyContent />
	</StyledLegalPage>
);
